import script from "./ForgetPasswordModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ForgetPasswordModal.vue?vue&type=script&setup=true&lang=js"

import "./ForgetPasswordModal.vue?vue&type=style&index=0&id=3cb5fe14&lang=less"

const __exports__ = script;

export default __exports__